export default {"src":"/_next/static/media/timor-leste.199de51c.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};